import { Card, CardContent, IconButton, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, Box, Button, Divider, ListItem, ListItemIcon, ListItemText, Toolbar, TextField, FormControlLabel, Switch, FormControl, InputLabel } from "@mui/material";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState, useEffect } from "react"
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { useNavigate } from 'react-router-dom';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MasterData from "../../../components/master-data/MasterData";
import { useAppSelector, useAppDispatch } from ".././../../app/hooks";
import { Controller } from "../../../lib/api-wrappers/Controller";
import uuid from "react-uuid";
import { useParams } from "react-router-dom";
import { defaultICarryDistribution, ICarryDistribution } from "./ICarryDistribution";
import { carryDistributionThunk, selectCarryDistribution } from "./carryDistributionSlice";
import { defaultICarryDistributionDetails, ICarryDistributionDetails } from "./ICarryDistributionDetails";
import { carryDistributionDetailsThunk, selectCarryDistributionDetails } from "./carryDistributionDetailsSlice";
import UploadComponents from "../subsections/uploadComponents";
import React, * as Rect from 'react'
import { updateStepperIndex } from '../subsections/sideNavBarSlice'
import { wrapArgument } from "../../../lib/api-status/actionWrapper";
import { createApplicationAsync } from "../../../../src/features/fundOverview/subsections/fundOverviewData/prelimApplicationDataSlice"
import { selectedDetailedApplications, detailedApplicationThunk } from "../../detailedApplication/sidbiReference/detailedApplicationSlice";
import { defaultIDetailedApplication } from "../../detailedApplication/sidbiReference/IDetailedApplication";
import { selectUsers } from '../../admin/adminSlice'
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import InputAdornment from '@mui/material/InputAdornment';
import { isAllDocsAvailable } from '../../fundOverview/subsections/preview/docsMandateApi'
import { ModalComponent } from '../../../components/ModalComponent'
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { secureDownload } from '../../../utils/downloadUtils';
import { blockOverflowNumericInput } from '../../../utils/validationUtils';

export const CarryDistribution = (props: any) => {


    const params = useParams()
    const parentId = Number(params.id)
    const [formData, setFormData] = useState(defaultICarryDistribution);
    const [newformDataDetails, setNewFormDataDetails] = useState(defaultICarryDistributionDetails);
    const [actionId] = useState(uuid());
    const controller = new Controller(actionId, carryDistributionThunk);
    const state = useAppSelector(selectCarryDistribution);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [formDataDetailsList, setFormDataDetailsList] = useState([] as any);
    const [formDataDetails, setFormDataDetails] = useState(defaultICarryDistributionDetails);
    const detailsController = new Controller(actionId, carryDistributionDetailsThunk);
    const detailsState = useAppSelector(selectCarryDistributionDetails);
    const detailedApplicationState = useAppSelector(selectedDetailedApplications);
    const detailedController = new Controller(actionId, detailedApplicationThunk);
    const [prilimFormData, setPrilimFormData] = useState(defaultIDetailedApplication);
    const [commentPreview, setCommentPreview] = useState<String | undefined>(" ");
    const usersState = useAppSelector(selectUsers)
    const reviewedByIdDetailed = prilimFormData.reviewedByUserId
    const currentAdminId = usersState.me?.id
    const isCurrentUserForwarderDetailed =
        reviewedByIdDetailed != null &&
        currentAdminId != null &&
        Number(reviewedByIdDetailed) === Number(currentAdminId)
    const approveDisabled =
        reviewedByIdDetailed != null &&
        (currentAdminId == null || Number(reviewedByIdDetailed) === Number(currentAdminId))
    const [deleteClicked, setDeleteClicked] = useState(false);
    const [showResponse, setShowResponse] = useState(false);

    //const prelimApplicationId = detailedApplicationState.

    useEffect(() => {
        if (props.checkUnAuth) {
            navigate('/login')
        }
    })


    useEffect(() => {
        dispatch(updateStepperIndex(4))
        if (parentId) {

            if (!state[parentId]?.data[0]) {
                setFormData({ ...formData, parentId: parentId })
                controller.all({ ...formData, parentId: parentId });
            }
        }
    }, [])

    useEffect(() => {
        dispatch(updateStepperIndex(4))
        if (state[parentId]?.data && Object.keys(state[parentId]?.data).length > 0 && props.isCrtStateToUpdate(state[parentId]?.data, defaultICarryDistribution)) {
            Object.keys(state[parentId]?.data).map((key) => {
                let value = state[parentId]?.data[key]
                if (value && value.id) {
                    setFormData(value);
                }
            });
        }
    }, [state[parentId]?.data])


    useEffect(() => {
        if (parentId) {

            if (!detailsState[parentId]?.data[0]) {
                setFormDataDetails({ ...formDataDetails, parentId: parentId })
                detailsController.all({ ...formDataDetails, parentId: parentId });
            }
        }
    }, [])

    /*useEffect(() => {
        if (parentId) {
                detailsController.all({ ...defaultICarryDistributionDetails, parentId: parentId });
        }
    }, [deleteClicked])*/

    useEffect(() => {
        if (detailsState[parentId]?.data && Object.keys(detailsState[parentId]?.data).length > 0 && props.isCrtStateToUpdate(detailsState[parentId]?.data, defaultICarryDistributionDetails)) {
            Object.keys(detailsState[parentId]?.data).map((key) => {
                let value = detailsState[parentId]?.data[key]
                if (value && value.id) {
                    setFormDataDetails(value);
                }
            });
        }
    }, [detailsState[parentId]?.data])

    useEffect(() => {
        if (detailsState[parentId]?.data != undefined && (Object.keys(detailsState[parentId]?.data).length > 0) && props.isCrtStateToUpdate(detailsState[parentId]?.data, defaultICarryDistributionDetails)) {
            let newData = detailsState[parentId]?.data;
            if (newData) {
                checkAndUpdate(newData)
                //setFormDataDetailsList(newData)
            }
        }
        else if (detailsState[parentId]?.data != undefined && Object.keys(detailsState[parentId]?.data).length == 0) {
            setFormDataDetailsList([] as any)
        }
    }, [detailsState[parentId]?.data])

    useEffect(() => {
        console.log("sampath test ", formDataDetailsList)
    }, [formDataDetailsList])

    useEffect(() => {

        if (parentId) {
            if (!detailedApplicationState[0]?.data[parentId]) {
                detailedController.fetch({ ...prilimFormData, id: parentId });
            }
        }
    }, [])

    useEffect(() => {

        let newData = detailedApplicationState[0]?.data[parentId];
        if (newData) setPrilimFormData(newData)
    }, [detailedApplicationState[0]?.data])

    const checkAndUpdate = (data: any) => {
        let outData = [] as any;
        Object.keys(data).map((d: any) => {
            if (props.isCrtStateToUpdate(data[d], defaultICarryDistributionDetails)) {
                outData.push(data[d])
            }
        })
        setFormDataDetailsList(outData)
    }

    /** inputProps for all financial numeric inputs: no scientific notation, max 9999 */
    const numericInputProps = { min: 0, max: 9999, step: 0.01 };

    const handleChange = (ev: any) => {
        ev.preventDefault();
        let copiedValue = { ...formData }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        copiedValue[key as keyof typeof formData] = ev.target.value;
        setFormData(copiedValue);
        return copiedValue;
    };

    const handleChangeCapitalBalanceAmount = (ev: any) => {
        ev.preventDefault();
        let copiedValue = { ...formData }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        copiedValue[key as keyof typeof formData] = ev.target.value;
        copiedValue['capitalBalance'] =  String(Number(formData["corpusAssumed"] || 0) - ev.target.value);
        setFormData(copiedValue);
        handleChangeAllBalanceAmount(copiedValue);
    };

    const handleChangeHurdleBalanceAmount = (ev: any) => {
        ev.preventDefault();
        let copiedValue = { ...formData }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        copiedValue[key as keyof typeof formData] = ev.target.value;
        copiedValue['hurdleBalance'] =  String((Number(formData["corpusAssumed"] || 0) - Number(formData["capitalAmount"] || 0)) - ev.target.value);
        setFormData(copiedValue);
        handleChangeAllBalanceAmount(copiedValue);
    };

    const handleChangeCatchupBalanceAmount = (ev: any) => {
        ev.preventDefault();
        let copiedValue = { ...formData }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        copiedValue[key as keyof typeof formData] = ev.target.value;
        copiedValue['catchupBalance'] =  String(((Number(formData["corpusAssumed"] || 0) - Number(formData["capitalAmount"] || 0)) - Number(formData["hurdleAmount"] || 0)) - ev.target.value);
        setFormData(copiedValue);
        handleChangeAllBalanceAmount(copiedValue);
    };

    const handleChangeProfitBalanceAmount = (ev: any) => {
        ev.preventDefault();
        let copiedValue = { ...formData }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        copiedValue[key as keyof typeof formData] = ev.target.value;
        copiedValue['profitBalance'] =  String((((Number(formData["corpusAssumed"] || 0) - Number(formData["capitalAmount"] || 0)) - Number(formData["hurdleAmount"] || 0)) - Number(formData["catchupAmount"] || 0)) - ev.target.value);
        setFormData(copiedValue);
        handleChangeAllBalanceAmount(copiedValue);
    };

    const handleChangeCarryBalanceAmount = (ev: any) => {
        ev.preventDefault();
        let copiedValue = { ...formData }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        copiedValue[key as keyof typeof formData] = ev.target.value;
        copiedValue['carryBalance'] =  String(((((Number(formData["corpusAssumed"] || 0) - Number(formData["capitalAmount"] || 0)) - Number(formData["hurdleAmount"] || 0)) - Number(formData["catchupAmount"] || 0)) - Number(formData["profitAmount"] || 0)) - ev.target.value);
        setFormData(copiedValue);
        handleChangeAllBalanceAmount(copiedValue);
    };

    const handleChangeAllBalanceAmount = (copiedValue: any) => {
        copiedValue['capitalBalance'] =  String(Number(copiedValue["corpusAssumed"] || 0) - Number(copiedValue["capitalAmount"] || 0));
        copiedValue['hurdleBalance'] =  String((Number(copiedValue["corpusAssumed"] || 0) - Number(copiedValue["capitalAmount"] || 0)) - Number(copiedValue["hurdleAmount"] || 0));
        copiedValue['catchupBalance'] =  String(((Number(copiedValue["corpusAssumed"] || 0) - Number(copiedValue["capitalAmount"] || 0)) - Number(copiedValue["hurdleAmount"] || 0)) - Number(copiedValue["catchupAmount"] || 0));
        copiedValue['profitBalance'] =  String((((Number(copiedValue["corpusAssumed"] || 0) - Number(copiedValue["capitalAmount"] || 0)) - Number(copiedValue["hurdleAmount"] || 0)) - Number(copiedValue["catchupAmount"] || 0)) - Number(copiedValue["profitAmount"] || 0));
        copiedValue['carryBalance'] =  String(((((Number(copiedValue["corpusAssumed"] || 0) - Number(copiedValue["capitalAmount"] || 0)) - Number(copiedValue["hurdleAmount"] || 0)) - Number(copiedValue["catchupAmount"] || 0)) - Number(copiedValue["profitAmount"] || 0)) - Number(copiedValue["carryAmount"] || 0));
        setFormData(copiedValue);
    };

    const handleNewChange = (ev: any) => {
        ev.preventDefault();
        let copiedValue = { ...newformDataDetails }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        copiedValue[key as keyof typeof newformDataDetails] = ev.target.value;
        copiedValue.parentId = parentId;
        setNewFormDataDetails(copiedValue);
    };

    const handleChangeCarryDetails = (ev: any, id_key: any) => {
        ev.preventDefault();
        let copiedValue = { ...formDataDetailsList }
        let key = ev.target.id ? ev.target.id : ev.target.name;
        let statusCopy = Object.assign({}, copiedValue[id_key]);
        statusCopy[key] = ev.target.value;
        let obj = {} as any
        obj[id_key] = statusCopy
        copiedValue = { ...copiedValue, ...obj }
        setFormDataDetailsList(copiedValue);
    };

    const handleSaveDetails = () => {
        for (let i = 0; i < Object.keys(formDataDetailsList).length; i++) {
            detailsController.save(formDataDetailsList[Object.keys(formDataDetailsList)[i]]);
        }
        if (newformDataDetails.parentId != undefined) {
            detailsController.save(newformDataDetails);
        }
        setNewFormDataDetails(defaultICarryDistributionDetails);
    }

    const handleDeleteDetails = (ev: any, data: ICarryDistributionDetails) => {
        if (data.id != undefined && data.parentId) {
            detailsController.delete(data);
        }
    }

    const handleSave = () => {
        controller.save(formData);
        handleSaveDetails()

    }

    //sum of 1 to 5
    const getAmount = () => {
        let sum = (Number(formData?.capitalAmount) || 0) + (Number(formData?.hurdleAmount) || 0) + (Number(formData.catchupAmount) || 0) + (Number(formData.profitAmount) || 0) + (Number(formData.carryAmount || 0))
        console.log(sum)
        return sum
    }

    //sum of 1 to 5 balance
    const getBalanceAmount = () => {
        let sum = (Number(formData?.corpusAssumed) || 0) - ((Number(formData?.capitalAmount) || 0) + (Number(formData?.hurdleAmount) || 0) + (Number(formData.catchupAmount) || 0) + (Number(formData.profitAmount) || 0) + (Number(formData.carryAmount || 0)))
        console.log(sum)
        return sum
    }

    //profit of investor
    const getProfitOfInvestors = () => {
        let sum = ((Number(formData?.hurdleAmount) || 0) + (Number(formData.profitAmount) || 0))
        console.log(sum)
        return sum
    }

    //profit of investor balance
    const getBalanceProfitOfInvestors = () => {
        let sum = ((Number(formData?.hurdleBalance) || 0) + (Number(formData.profitBalance) || 0))
        console.log(sum)
        return sum
    }

    //Distribution Amouunt
    const getDisAmount = () => {
        let sum = ((Number(formData?.catchupAmount) || 0) + (Number(formData.carryAmount) || 0))
        console.log(sum)
        return sum
    }

    //Balance Distribution Amouunt
    const getDisBalanceAmount = () => {
        let sum = ((Number(formData?.catchupBalance) || 0) + (Number(formData.carryBalance) || 0))
        console.log(sum)
        return sum
    }

    const getTotalPercent = () => {
        let percentTotal = 0;

        if (formDataDetailsList != undefined) {
            let keysArr = Object.keys(formDataDetailsList)
            for (let i = 0; i < keysArr.length; i++) {
                percentTotal = Number(formDataDetailsList[keysArr[i]]["percent"]) + percentTotal;
            }
            return percentTotal
        }
    }

    const getTotalOutOfCarry = () => {
        let carryOutOfCroreTotal = 0;
        
        if (formDataDetailsList != undefined) {
            let keysArr = Object.keys(formDataDetailsList)
            for (let i = 0; i < keysArr.length; i++) {
                carryOutOfCroreTotal = Number(formDataDetailsList[keysArr[i]]["carryOutOfCrore"]) + carryOutOfCroreTotal;
            }
            return carryOutOfCroreTotal
        }
    }

    const handleClose= () => {
        setShowResponse(false)
    };


    const handleClickSave = (ev: any, navTo: string) => {
        handleSave()
        if (navTo === 'previous') {
            navigate(`/Detailed/${parentId}/EngagementAndRole`);
        }
    }

    const handlePreviewComments = (ev: any) => {
        ev.preventDefault();
        console.log('handle change', ev, ev.target.id, ev.target.value);
        setCommentPreview(ev.target.value)
    };

    const [actionDate, setActionDate] = useState<Date>(prilimFormData.actionDate || new Date());
    const [actionDateError, setActionDateError] = useState<string | undefined>();

    async function handleClickSaveCloseAction(ev: any) {

        setActionDateError(undefined);

        if(actionDate === null || actionDate == undefined) {
            setActionDateError("Please entre an action date.");
        } else {
            console.log("prelimId", parentId)
            handleSave()
            dispatch(
                createApplicationAsync(
                    wrapArgument(
                        actionId, { 
                            id: Number(prilimFormData.prelimApplicationId), 
                            statusComments: commentPreview, 
                            actionDate: actionDate,
                            status: ev.target.id }
                    )
                )
            );
            navigate('/home')
        }
    }

    async function handleClickSubmit(ev: any) {
        
        setActionDateError(undefined);

        // if (await checkAllDocsOk(parentId, "detailed")) {
            console.log("prelimId", parentId)
            handleSave()
            dispatch(
                createApplicationAsync(
                    wrapArgument(
                        actionId, { id: Number(prilimFormData.prelimApplicationId), statusComments: commentPreview, status: ev.target.id }
                    )
                )
            );
            navigate('/home')
        // }
        // else {
            // setShowResponse(true);
        // }
    }

    async function checkAllDocsOk(id: any, applicationName: any) {
        if (usersState.role === 'ADMIN'){
            return true
        }
        try {
            const res = await isAllDocsAvailable(id, applicationName)
            if (res.status === 200) {
                return true
            }
            else {
                return false
            }
        } catch (reason) {
            console.log(reason);
            return false
        }
    }

    let carryDetailsComponent = []
    if (formDataDetailsList != undefined) {
        let keysArr = Object.keys(formDataDetailsList)
        for (let i = 0; i < keysArr.length; i++) {
            carryDetailsComponent.push(
                <React.Fragment >
                    <Grid container spacing={6} >
                        <Grid item xs={6}>
                            <TextField
                                required
                                id="distribution"
                                label=""
                                //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                value={formDataDetailsList[keysArr[i]]["distribution"] || ''}
                                variant="standard"
                                onChange={(e) => handleChangeCarryDetails(e, keysArr[i])}

                                sx={{ display: 'flex', ml: 2 }}
                            />
                        </Grid>
                        <Grid item xs={2.5}>
                            <TextField
                                required
                                type="number"
                                onKeyDown={blockOverflowNumericInput}
                                inputProps={numericInputProps}
                                id="percent"
                                label=""
                                //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                value={formDataDetailsList[keysArr[i]]["percent"] || ''}
                                variant="standard"
                                onChange={(e) => handleChangeCarryDetails(e, keysArr[i])}

                                sx={{ display: 'flex' }}
                            />
                        </Grid>

                        <Grid item xs={2.5}>
                            <TextField
                                required
                                type="number"
                                onKeyDown={blockOverflowNumericInput}
                                inputProps={numericInputProps}
                                id="carryOutOfCrore"
                                label=""
                                //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                value={formDataDetailsList[keysArr[i]]["carryOutOfCrore"] || ''}
                                variant="standard"
                                onChange={(e) => handleChangeCarryDetails(e, keysArr[i])}

                                sx={{ display: 'flex' }}
                            />
                        </Grid>

                        <Grid item xs={1} >
                            <IconButton onClick={(e) => handleDeleteDetails(e, formDataDetailsList[keysArr[i]])}>
                                <CloseIcon className="remove_icon" sx={{ hover: 'blue' }} ></CloseIcon>
                            </IconButton>
                            {/*<Button
                                //onClick={(e) => handleClickSave(e, "previous")}
                                onClick={(e) => handleDeleteDetails(e, formDataDetailsList[keysArr[i]])}
                                startIcon={<ArrowLeftIcon />}
                                variant="contained"
                                disableElevation
                                sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                Back
            </Button>*/}
                        </Grid>

                    </Grid>
                    <br></br>
                </React.Fragment>)
        }
    }
console.log(prilimFormData);
    return (<>

        <Grid item xs={12}>


            <Card sx={{ display: 'flex', mb: 2, mt: 2 }}>
                <CardContent sx={{ flex: 1 }}>

                {usersState.role === 'USER' || process.env.REACT_APP_MIGRATION_TESTING === 'Y' ? <Typography variant="h6" sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2 }}>Illustration of carry distribution of the Fund</Typography> : <><Typography variant="h6" sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2 }}>{prilimFormData.sidbiReferenceNumber}</Typography>
                <Typography variant="h6" sx={{ flex: 1, fontWeight: 'bolder', color: '#333333', mb: 2 }}>Name of the Fund: {prilimFormData.nameOfTheFund}</Typography></> }

                    <Divider sx={{ mt: 2 }} />{usersState.role === 'USER' || process.env.REACT_APP_MIGRATION_TESTING === 'Y' ? <>
                        <Card sx={{ display: 'flex', mt: 3, background: '#f2f2f2' }}>
                            <CardContent sx={{ flex: 1 }}>
                                <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 2 }}>Carry Distribution</Typography>
                                <Grid container spacing={3}>
                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            id="corpus"
                                            label="Corpus[₹ In crore]"
                                            //defaultValue={formData.corpus === undefined ? " " : formData["corpus"]}
                                            value={formData["corpus"] || ''}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', ml: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="hurdle"
                                            label="Hurdle (%)"
                                            //defaultValue={formData.corpus === undefined ? " " : formData["corpus"]}
                                            value={formData["hurdle"] || ''}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', ml: 2, mb: 2 }}
                                        />
                                        {/*<FormControl variant="standard" sx={{ ml: 2, display: 'flex' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Hurdle</InputLabel>

                                        <MasterData propertyType="fundManager"
                                            propertyValue={Number(formData.hurdle) || 0}
                                            //propertyValue={formData.hurdle || 0}
                                            onChange={handleSelectChange} />
    </FormControl>*/}
                                    </Grid>

                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="catchup"
                                            label="Catchup(%)"
                                            //defaultValue={formData.corpus === undefined ? " " : formData["corpus"]}
                                            value={formData["catchup"] || ''}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', ml: 2, mb: 2 }}
                                        />
                                        {/*}
                                    <FormControl variant="standard" sx={{ ml: 2, display: 'flex' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Catchup(%)</InputLabel>

                                        <MasterData propertyType="fundManager"
                                            propertyValue={Number(formData.catchup) || 0}
                                            onChange={handleSelectChange} />
</FormControl>*/}
                                    </Grid>

                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="carry"
                                            label="Carry(%)"
                                            //defaultValue={formData.corpus === undefined ? " " : formData["corpus"]}
                                            value={formData["carry"] || ''}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', ml: 2, mb: 2 }}
                                        />
                                        {/*}
                                    <FormControl variant="standard" sx={{ ml: 2, display: 'flex' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Carry(%)</InputLabel>

                                        <MasterData propertyType="fundManager"
                                            propertyValue={0}
                                            //propertyValue={formData.fundManager || 0}
                                            onChange={handleSelectChange} />
</FormControl>*/}
                                    </Grid>

                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="profit"
                                            label="Profit to investors(%)"
                                            //defaultValue={formData.corpus === undefined ? " " : formData["corpus"]}
                                            value={formData["profit"] || ''}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', ml: 2, mb: 2 }}
                                        />
                                        {/*}
                                    <FormControl variant="standard" sx={{ ml: 2, mt: 2, display: 'flex' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Profit to investors(%)</InputLabel>

                                        <MasterData propertyType="fundManager"
                                            propertyValue={0}
                                            //propertyValue={formData.fundManager || 0}
                                            onChange={handleSelectChange} />
</FormControl>*/}
                                    </Grid>

                                    <Grid item xs={6}>

                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="corpusAssumed"
                                            label="Distributable corpus assumed for illustration[₹ Crore]"
                                            //defaultValue={formData.corpus === undefined ? " " : formData["corpus"]}
                                            value={formData["corpusAssumed"] || ''}
                                            variant="standard"
                                            onChange={(ev: any) => {
                                                let formDataUpdate = handleChange(ev);
                                                handleChangeAllBalanceAmount(formDataUpdate);
                                            }}

                                            sx={{ display: 'flex', ml: 2, mb: 2 }}
                                        />
                                        {/*}
                                    <FormControl variant="standard" sx={{ ml: 2, mt: 2, display: 'flex' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Distributable corpus assumed for illustration[₹ Crore]</InputLabel>

                                        <MasterData propertyType="fundManager"
                                            propertyValue={0}
                                            //propertyValue={formData.fundManager || 0}
                                            onChange={handleSelectChange} />
</FormControl> */}
                                    </Grid>
                                </Grid>

                                <Divider sx={{ mt: 7, mb: 2 }} />

                                <Grid container spacing={6} >
                                    <Grid item xs={6}></Grid>
                                    <Grid item xs={3}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>Amount</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>Balance Amount</Typography>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, ml: 2, justifyContent: 'center' }}>1.Capital to Investors (₹ Crore)</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="capitalAmount"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["capitalAmount"] || ''}
                                            variant="standard"
                                            onChange={(ev: any) => {
                                                handleChange(ev);
                                                handleChangeCapitalBalanceAmount(ev);
                                            }}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="capitalBalance"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["capitalBalance"] || ''}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, ml: 2, justifyContent: 'center' }}>2.Hurdle to the Investors (…….% on Capital to Investors) – ₹ Crore</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="hurdleAmount"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["hurdleAmount"] || ''}
                                            variant="standard"
                                            onChange={(ev: any) => {
                                                handleChange(ev);
                                                handleChangeHurdleBalanceAmount(ev);
                                            }}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="hurdleBalance"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["hurdleBalance"] || ''}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, ml: 2, justifyContent: 'center' }}>3.Catchup to Fund Manager (…….% on Hurdle to Investors) – ₹ Crore</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="catchupAmount"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["catchupAmount"] || ''}
                                            variant="standard"
                                            onChange={(ev: any) => {
                                                handleChange(ev);
                                                handleChangeCatchupBalanceAmount(ev);
                                            }}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="catchupBalance"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["catchupBalance"] || ''}
                                            variant="standard"
                                            onChange={handleChange}
                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, ml: 2, justifyContent: 'center' }}>4.Profit to the Investors(..% after catch up i.e, 80% on ₹.cr)– ₹ Crore</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="profitAmount"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["profitAmount"] || ''}
                                            variant="standard"
                                            onChange={(ev: any) => {
                                                handleChange(ev);
                                                handleChangeProfitBalanceAmount(ev);
                                            }}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="profitBalance"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["profitBalance"]}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, ml: 2, justifyContent: 'center' }}>5.Carry to Fund Manager (…….% on ₹ ………………… crore) – ₹ Crore</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="carryAmount"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["carryAmount"]}
                                            variant="standard"
                                            onChange={(ev: any) => {
                                                handleChange(ev);
                                                handleChangeCarryBalanceAmount(ev);
                                            }}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="carryBalance"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={formData["carryBalance"]}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}></Grid>
                                    <Grid item xs={3}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>{"Total " + getAmount()}</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>{getBalanceAmount()}</Typography>
                                    </Grid>

                                </Grid>

                                <Divider sx={{ mt: 2 }} />

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, ml: 2, justifyContent: 'center' }}>6.Profit to Investors (2+4) ) – ₹ Crore</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="profittoInvestorsAmount"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={Number(formData.hurdleAmount || 0) + Number(formData.profitAmount || 0)}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="profittoInvestors"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={Number(formData.hurdleBalance || 0) + Number(formData.profitBalance || 0)}
                                            variant="standard"
                                            // onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, ml: 2, justifyContent: 'center' }}>7.Distribution/Carry with Catchup to IM (3+5) ) – ₹ Crore</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="distributionAmount"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={Number(formData.catchupAmount || 0) + Number(formData.carryAmount || 0)}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <TextField
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            required
                                            type="number"
                                            onKeyDown={blockOverflowNumericInput}
                                            inputProps={numericInputProps}
                                            id="distribution"
                                            //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                            value={Number(formData.catchupBalance || 0) + Number(formData.carryBalance || 0)}
                                            variant="standard"
                                            onChange={handleChange}

                                            sx={{ display: 'flex', mt: 2, mb: 2 }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={6} >
                                    <Grid item xs={6}></Grid>
                                    <Grid item xs={3}>

                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>{"Total " + (getProfitOfInvestors() + getDisAmount())}</Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>{getBalanceProfitOfInvestors() + getDisBalanceAmount()}</Typography>
                                    </Grid>

                                </Grid>

                                <Divider sx={{ mt: 2 }} />

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>Distribution of Carry:</Typography>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>Carry%</Typography>

                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>Out of ₹ crore Carry</Typography>

                                    </Grid>
                                </Grid>
                                {carryDetailsComponent}

                                {detailsState[parentId]?.status[actionId]?.actionStatus.fetchStatus == 'idle' ?
                                    <Grid container spacing={6} >
                                        <Grid item xs={6}>
                                            <TextField
                                                required
                                                id="distribution"
                                                label=""
                                                //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                                value={newformDataDetails["distribution"]}
                                                variant="standard"
                                                onChange={handleNewChange}

                                                sx={{ display: 'flex', mt: 2, ml: 2 }}
                                            />
                                        </Grid>
                                        <Grid item xs={2.5}>
                                            <TextField
                                                required
                                                type="number"
                                                onKeyDown={blockOverflowNumericInput}
                                                inputProps={numericInputProps}
                                                id="percent"
                                                label="%"
                                                //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                                value={newformDataDetails["percent"]}
                                                variant="standard"
                                                onChange={handleNewChange}

                                                sx={{ display: 'flex', mb: 2 }}
                                                InputProps={{
                                                    endAdornment: <>%</>,
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={2.5}>
                                            <TextField
                                                required
                                                type="number"
                                                onKeyDown={blockOverflowNumericInput}
                                                inputProps={numericInputProps}
                                                id="carryOutOfCrore"
                                                label=" "
                                                //defaultValue={formData.fundLaunchedDate === undefined ? " " : formData["fundLaunchedDate"]}
                                                value={newformDataDetails["carryOutOfCrore"]}
                                                variant="standard"
                                                onChange={handleNewChange}

                                                sx={{ display: 'flex', mb: 2 }}
                                            />
                                        </Grid>

                                        <Grid item xs={1} >
                                            <IconButton onClick={handleSaveDetails}>
                                                <AddIcon className="add_icon" sx={{ mt: 2, hover: 'blue' }} ></AddIcon>
                                            </IconButton>
                                        </Grid>

                                    </Grid>
                                    : <></>}

                                <Grid container spacing={6} >
                                    <Grid item xs={6}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, textAlign: 'right' }}>Total</Typography>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, textAlign: 'left' }}>{getTotalPercent()}</Typography>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                        <Typography sx={{ flex: 1, mt: 3, mb: 3, textAlign: 'left' }}>{getTotalOutOfCarry()}</Typography>
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                        <Divider sx={{ mt: 2 }} />

                        <Card sx={{ display: 'flex', mt: 3, background: '#f2f2f2' }}>
                            <CardContent sx={{ flex: 1 }}>
                                <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 2 }}>Attachment Of Signed Document</Typography>
                                <Typography variant='body2' sx={{ flex: 1, color: '#363062', mb: 2, mt: 5 }}>* If application is in revision state Please download all pdf, copy sign it again and upload it then procced to submit.</Typography>

                                <Card sx={{ display: 'flex', mt: 3, background: '#ffffff' }}>
                                    <CardContent sx={{ flex: 1 }}>
                                        <Toolbar disableGutters sx={{ mt: -2, ml: -2, mr: -2, justifyContent: "center", backgroundColor: '#d9d9d9' }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 2, ml: 2 }}>Section Name</Typography>

                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 2, ml: 2 }}>Download unsigned document</Typography>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 2, ml: 2 }}>Upload signed document</Typography>
                                                </Grid>
                                            </Grid>
                                        </Toolbar>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 4 }}>Detailed Application</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    <FileDownloadIcon onClick={() => window.open(`${process.env.REACT_APP_API_BASE_URL}/api/detailedApplications/${parentId}/downloadPreview?access_token=${localStorage.getItem('token')}`)} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    {/* <Grid item xs={3}> */}
                                                    <div style={{ margin: "15px" }}>
                                                        <UploadComponents id={`carryDetailedApplication${parentId}`} signed={true}></UploadComponents>
                                                    </div>
                                                    {/* </Grid> */}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ mt: 2 }} />

                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 4 }}>Investment Theme of Fund</Typography>

                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    <FileDownloadIcon onClick={() => window.open(`${process.env.REACT_APP_API_BASE_URL}/api/detailedApplications/${parentId}/downloadInvestmentThemeOfFundPreview?access_token=${localStorage.getItem('token')}`)} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    {/* <Grid item xs={3}> */}
                                                    <div style={{ margin: "15px" }}>
                                                        <UploadComponents id={`carryInvestmentThemeOfFund${parentId}`} signed={true}></UploadComponents>
                                                    </div>
                                                    {/* </Grid> */}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ mt: 2 }} />

                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 4 }}>Detailed engagement and role of IM with Portfolio Companies</Typography>

                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    <FileDownloadIcon onClick={() => window.open(`${process.env.REACT_APP_API_BASE_URL}/api/detailedApplications/${parentId}/downloadEngagementAndRolePreview?access_token=${localStorage.getItem('token')}`)} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    {/* <Grid item xs={3}> */}
                                                    <div style={{ margin: "15px" }}>
                                                        <UploadComponents id={`carryDetailedEngagement${parentId}`} signed={true}></UploadComponents>
                                                    </div>
                                                    {/* </Grid> */}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ mt: 2 }} />

                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography sx={{ flex: 1, fontWeight: 'bolder', color: '#363062', mb: 2, mt: 4 }}>Illustration of carry distribution of the Fund</Typography>

                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    <FileDownloadIcon onClick={() => window.open(`${process.env.REACT_APP_API_BASE_URL}/api/detailedApplications/${parentId}/downloadCarryDistributionPreview?access_token=${localStorage.getItem('token')}`)} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Box sx={{ mb: 2, mt: 4, ml: 2 }}>
                                                    {/* <Grid item xs={3}> */}
                                                    <div style={{ margin: "15px" }}>
                                                        <UploadComponents id={`carryIllustration${parentId}`} signed={true}></UploadComponents>
                                                    </div>
                                                    {/* </Grid> */}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{ mt: 2 }} />


                                    </CardContent>
                                </Card>
                            </CardContent>
                        </Card> </> : <></>}
                    <Grid container xs={12}>
                        <Grid item xs={12}>
                            <Card sx={{ display: 'flex', mt: 2, background: '#f2f2f2' }}>
                                <CardContent sx={{ flex: 1 }}>
                                    <TextField
                                        required
                                        id="previewComments"
                                        label="Leave a comment"
                                        //defaultValue={formData.commitmentReceived === undefined ? " " : formData["commitmentReceived"]}
                                        //value={formData["commitmentReceived"] || ''}
                                        variant="standard"
                                        multiline
                                        onChange={handlePreviewComments}

                                        sx={{ display: 'flex', }}
                                    />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={4}>
                        {usersState.role === 'USER' || process.env.REACT_APP_MIGRATION_TESTING === 'Y' ? <Button
                                onClick={(e) => handleClickSave(e, "previous")}
                                startIcon={<ArrowLeftIcon />}
                                variant="contained"
                                disableElevation
                                disabled={!(usersState.role === 'USER' || process.env.REACT_APP_MIGRATION_TESTING === 'Y')}
                                sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                Back
                            </Button>: <></>}
                        </Grid>
                        <Grid item xs={4} >
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {usersState.role === 'USER' || process.env.REACT_APP_MIGRATION_TESTING === 'Y' ? <Typography sx={{ flex: 1, mt: 3, mb: 3, justifyContent: 'center' }}>Step 5 of 5</Typography> : <></>}
                            </Box>
                        </Grid>

                        <Grid item xs={4} sx={{ justifyContent: 'right' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                {!(prilimFormData.status == 'SUBMITTED' || prilimFormData.status == 'REVIEWED' || prilimFormData.status == 'TEMP_CLOSED' || prilimFormData.status == 'CLOSED') ? <><Button
                                    //onClick={(e) => handleClickSave(e, "submit")}
                                    // onClick={handleClickSubmit}
                                    onClick={handleClickSubmit}
                                    //endIcon={<ArrowRightIcon />}
                                    id='submit'
                                    color='success'
                                    variant="contained"
                                    disableElevation
                                    sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2, mr: 2 }} >
                                    Submit
                                </Button>
                                    <Button
                                        //onClick={(e) => handleClickSave(e, "submit")}
                                        // onClick={handleClickSubmit}
                                        onClick={handleSave}
                                        //endIcon={<ArrowRightIcon />}
                                        id='submit'
                                        color='success'
                                        variant="contained"
                                        disableElevation
                                        sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2, mr: 2 }} >
                                        Save
                                    </Button>
                                </> : ['ADMIN', 'USERADMIN'].includes(usersState.role != undefined ? usersState.role : '') ?

                                    <>
                                        {prilimFormData.status === 'SUBMITTED' && (
                                            <>
                                                <Button color='success' id='review' onClick={handleClickSubmit} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                                    Forward for approval
                                                </Button>
                                                <Button color='warning' id='revise' onClick={handleClickSubmit} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                                    Revise
                                                </Button>
                                                <Button color='error' id='reject' onClick={handleClickSubmit} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                                    Reject
                                                </Button>
                                            </>
                                        )}
                                        {prilimFormData.status === 'REVIEWED' && (
                                            <>
                                                {isCurrentUserForwarderDetailed && (
                                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 3, mb: 1, ml: 2, maxWidth: 480 }}>
                                                        Another administrator must approve. You forwarded this application for approval.
                                                    </Typography>
                                                )}
                                                <Button
                                                    color='success'
                                                    id='approve'
                                                    onClick={handleClickSubmit}
                                                    variant="contained"
                                                    disableElevation
                                                    disabled={approveDisabled}
                                                    title={approveDisabled ? 'Only an administrator other than the one who forwarded may approve.' : undefined}
                                                    sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }}
                                                >
                                                    Approve
                                                </Button>
                                                <Button color='warning' id='revise' onClick={handleClickSubmit} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                                    Revise
                                                </Button>
                                                <Button color='error' id='reject' onClick={handleClickSubmit} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                                    Reject
                                                </Button>
                                            </>
                                        )}
                                    </> : <></>}
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Card sx={{ display: 'flex', mt: 2, background: '#f2f2f2' }}>
                                <CardContent sx={{ flex: 1 }}>
                                    {usersState.role == 'ADMIN' && <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Effective date"
                                        inputFormat='DD/MM/YYYY'
                                        value={actionDate}
                                        onChange={(newValue) => newValue && setActionDate(newValue)}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    </LocalizationProvider>}
                                    <Typography variant="caption" color="error" sx={{ ml: '20px' }}>
                                        <>{actionDateError}</>
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={4} sx={{ justifyContent: 'right' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
                                {(['ADMIN', 'USERADMIN'].includes(usersState.role != undefined ? usersState.role : '') && (prilimFormData.status === 'SUBMITTED' || prilimFormData.status === 'REVIEWED')) ?
                                    <>
                                        <Button color='error' id='permClose' onClick={handleClickSaveCloseAction} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                            Close
                                        </Button>
                                        <Button color='error' id='tempClose' onClick={handleClickSaveCloseAction} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                            Temp Close
                                        </Button>
                                    </> : (['ADMIN', 'USERADMIN'].includes(usersState.role != undefined ? usersState.role : '') && prilimFormData.status === 'TEMP_CLOSED') ? 
                                    <Button color='error' id='reopen' onClick={handleClickSaveCloseAction} variant="contained" disableElevation sx={{ textTransform: 'none', mt: 3, mb: 3, ml: 2 }} >
                                        Reopen
                                    </Button> :  <></>}
                            </Box>
                        </Grid>
                    </Grid>
                    {showResponse ? <ModalComponent
                        open={showResponse}
                        close={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        className="special_modal"
                        msg={"Please upload all Documents before submitting the Application"}
                        status={"error"}
                    >
                    </ModalComponent> : <></>}
                </CardContent>
            </Card>
        </Grid>
    </>
    );

}


export default CarryDistribution;